module.exports = __webpack_public_path__ + "assets/img/51463c7baf805590f594ffcf218d2207.svg";